<div class="modal-header">
  <h4 class="modal-title mt-0" id="modal-basic-title" translate>
    {{ isEdit ? ('EDIT' | translate) : ('ADD' | translate) }} {{ 'POD' | translate }}
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="row" [formGroup]="deliveryLocationForm">
    <div class="col-12 no-form-group-margin-input-horizontal">
      <lib-gung-text-input-horizontal
        gungTranslate="COMPANY"
        formControlName="customerNameShow"
        [placeholder]="'' | translate"
        [disabled]="true"
      ></lib-gung-text-input-horizontal>
    </div>

    <div class="col-12">
      <hr />
    </div>

    <div class="col-12">
      <lib-gung-text-input-horizontal
        gungTranslate="NAME"
        formControlName="companyName"
        [placeholder]="'NAME' | translate"
      ></lib-gung-text-input-horizontal>
    </div>

    <div class="col-12">
      <lib-gung-text-input-horizontal
        gungTranslate="CO_ADDRESS"
        formControlName="address"
        [placeholder]="'ADDRESS' | translate"
      ></lib-gung-text-input-horizontal>
    </div>

    <div class="col-12">
      <lib-gung-text-input-horizontal
        gungTranslate="STREET"
        formControlName="street"
        [placeholder]="'STREET' | translate"
      ></lib-gung-text-input-horizontal>
    </div>

    <div class="col-12 col-sm-7">
      <lib-gung-text-input-horizontal
        gungTranslate="POSTAL_CODE"
        formControlName="postalCode"
        [placeholder]="'POSTAL_CODE' | translate"
        labelClass="col-12 col-sm-7 postal-code-max-width-sm"
      ></lib-gung-text-input-horizontal>
    </div>

    <div class="col-12 col-sm-5">
      <lib-gung-text-input-horizontal
        gungTranslate="CITY"
        formControlName="city"
        [placeholder]="'CITY' | translate"
      ></lib-gung-text-input-horizontal>
    </div>

    <div class="col-12">
      <lib-gung-select-option-input-horizontal
        gungTranslate="COUNTRY"
        [optionsList]="countryOptions"
        formControlName="country"
      ></lib-gung-select-option-input-horizontal>
    </div>

    <div class="col-12">
      <lib-meta-select-input-horizontal
        table="q_companytype"
        metaId="q_companytypeid"
        metaDisplay="q_companytypedescr"
        formControlName="companyType"
        gungTranslate="COMPANY_TYPE"
      ></lib-meta-select-input-horizontal>
    </div>

    <div class="col-12">
      <lib-gung-text-input-horizontal
        gungTranslate="EAN_ILN_NUMBER"
        formControlName="eanNumber"
        [placeholder]="'EAN_ILN_NUMBER' | translate"
      ></lib-gung-text-input-horizontal>
    </div>
  </div>
</div>

<div class="modal-footer">
  <div class="btn-group btn-group-justified btn-group-bottom">
    <button class="btn btn-primary" [disabled]="isEdit || creating" (click)="save()">
      {{ isEdit ? ('SAVE' | translate) : ('ADD' | translate) }}
    </button>
    <button class="btn btn-outline-primary" (click)="close()" translate>CANCEL</button>
  </div>
</div>
